import { createContext, useReducer, useEffect } from 'react'

export const AuthContext = createContext()

const initialState = {
	user: null,
}

export const authReducer = (state, action) => {
	switch (action.type) {
		case 'LOGIN':
			return { user: action.payload }
		case 'LOGOUT':
			return { user: null }
		default:
			return state
	}
}

export const AuthContextProvider = ({ children }) => {
	const [state, dispatch] = useReducer(authReducer, initialState, () => {
		try {
			const localUser = localStorage.getItem('user')
			return localUser ? JSON.parse(localUser) : initialState
		} catch (error) {
			//Ideally this is where I would dispatch an 'ERROR' to the Reducer
			console.log(error)
		}
	})

	useEffect(() => {
		localStorage.setItem('user', JSON.stringify(state))
	}, [state])
	return (
		<AuthContext.Provider value={{ ...state, dispatch }}>
			{children}
		</AuthContext.Provider>
	)
}
